import React from 'react';

const StepIntro = ({ children }) => {
    return (
        <strong className="clx-step__intro" tabIndex={0}>
            {children}
        </strong>
    );
};

export default StepIntro;
